<template>
  <div class='EnbInfoProd02'
  :style="{
    backgroundColor: Prefes.produto.corBackground,
    'color': Prefes.produto.corFont,
    'font-family': Prefes.produto.font,
    fontStyle: parseInt(Prefes.produto.fontStyle) ? 'italic' : '',
    fontWeight: parseInt(Prefes.produto.fontBold) ? 'bold' : '',
    textDecoration: parseInt(Prefes.produto.textDecoration) ? 'underline' : '',
    fontSize: Prefes.produto.fontHeight + 'px'
  }"
  >
    <div class="cont-name">
      {{ data.name }}
    </div>
    <div class="cont-endereco">
      <location-icon :color="Prefes.produto.corFont"/>
      <div>{{ endereco }}</div>
    </div>
    <div class="cont-caracter">
      <div class="caracter">
        <div><rooms-icon :color="Prefes.produto.corFont"/></div>
        <div>{{ rooms }}</div>
      </div>
      <div class="caracter">
        <div><toilet-icon :color="Prefes.produto.corFont"/></div>
        <div>{{ toilet }}</div>
      </div>
      <div class="caracter">
        <div><parking-icon :color="Prefes.produto.corFont"/></div>
        <div>{{ parking }}</div>
      </div>
      <div class="caracter">
        <div><area-icon :color="Prefes.produto.corFont"/></div>
        <div>{{ area }}</div>
      </div>
    </div>
    <div class="cont-btn">
      <div class="cont-icon">
        <whats-icon color="green" @click="sendMessageWhats(data)"/>
      </div>
      <div class="cont-label" @click="sendMessageWhats(data)">
        Saiba mais
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LocationIcon from '../../../EnbPainel/Icons/LocationIcon'
import RoomsIcon from '../../../EnbPainel/Icons/RoomsIcon'
import ToiletIcon from '../../../EnbPainel/Icons/ToiletIcon'
import ParkingIcon from '../../../EnbPainel/Icons/ParkingIcon'
import AreaIcon from '../../../EnbPainel/Icons/AreaIcon'
import WhatsIcon from '../../Icons/WhatsIcon'
export default {
  name: 'EnbInfoProd02',
  props: ['data'],
  components: { LocationIcon, RoomsIcon, ToiletIcon, ParkingIcon, AreaIcon, WhatsIcon },
  computed: {
    ...mapGetters(['Prefes']),
    endereco () {
      let value = this.data.caracter.filter(c => c.icon === 'LocationIcon')
      return value.length ? value[0].name : ''
    },
    rooms () {
      let value = this.data.caracter.filter(c => c.icon === 'RoomsIcon')
      return value.length ? value[0].name : ''
    },
    toilet () {
      let value = this.data.caracter.filter(c => c.icon === 'ToiletIcon')
      return value.length ? value[0].name : ''
    },
    parking () {
      let value = this.data.caracter.filter(c => c.icon === 'ParkingIcon')
      return value.length ? value[0].name : ''
    },
    area () {
      let value = this.data.caracter.filter(c => c.icon === 'AreaIcon')
      return value.length ? value[0].name + ' m²' : ''
    }
  },
  methods: {
    ...mapActions(['sendMessageWhats'])
  }
}
</script>

<style scoped>
.EnbInfoProd02 {
  text-align: left;
  padding: 3%;
}

.cont-name {
  font-size: 22px;
}

.cont-endereco {
  display: flex;
  align-items: center;
  padding-top: 2%;
}

.cont-caracter {
  display: flex;
  padding-top: 2%;
}

.caracter {
  width: 20%;
  display: flex;
  align-items: center;
}

.caracter div {
  padding-right: 10%;
  white-space: nowrap;
}

.cont-btn {
  width: max-content;
  display: flex;
  align-items: center;
  border: thin solid green;
  padding: 2%;
  border-radius: 5px;
  margin-top: 2%;
}

.cont-label {
  cursor: pointer;
  color: green;
}

.cont-label:hover {
  text-decoration: underline;
}
</style>
